"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkApplicationServerClassName = exports.SYSTEM = exports.DataLifeCyclePeriod = exports.Milliseconds = void 0;
var iotv_v3_types_1 = require("@iotv/iotv-v3-types");
Object.defineProperty(exports, "Milliseconds", { enumerable: true, get: function () { return iotv_v3_types_1.Milliseconds; } });
Object.defineProperty(exports, "DataLifeCyclePeriod", { enumerable: true, get: function () { return iotv_v3_types_1.DataLifeCyclePeriod; } });
const projectCode = process.env.projectCode ?? process.env.REACT_APP_PROJECT_CODE;
const stage = process.env.stage ?? process.env.REACT_APP_DEPLOYMENT_STAGE;
const key = `${projectCode}-${stage}`;
exports.SYSTEM = {
    type: 'System',
    name: 'System',
    id: `${key}`,
    pk: `System:${key}`,
    sk: `System:${key}`,
};
exports.NetworkApplicationServerClassName = 'LoRaWANApplicationServer';
